var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-default-dialog-appbar',{attrs:{"back-to":_vm.rotaapontamento,"withDialog":!_vm.idatividade}},[_vm._v(" "+_vm._s((_vm.idatividade) ? '' : 'Cadastrar')+" Atividade "+_vm._s(_vm.idatividade)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }